<script setup lang="ts">
import SelectShiftFilter from './SelectShiftFilter.vue'
import ButtonFiltersSubmit from './ButtonFiltersSubmit.vue'
import ButtonFiltersClear from './ButtonFiltersClear.vue'
import SwitcherSlotsTracker from './SwitcherSlotsTracker.vue'

defineOptions({
  name: 'FiltersSlotsTracker',
})

</script>

<template>
  <div class="box-filters">
    <SwitcherSlotsTracker />
    <div class="box-filters__reservation">
      <SelectShiftFilter type="reservation-type" />
    </div>
    <div class="box-filters__slot">
      <SelectShiftFilter type="slot-status" />
    </div>
    <div class="box-filters__sort">
      <SelectShiftFilter type="sort-by" />
    </div>
    <ButtonFiltersSubmit />
    <ButtonFiltersClear />
  </div>
</template>

<style scoped lang="scss" src="./FiltersSlotsTracker.scss" />
